import React, { useState, useEffect } from 'react';

const Splash = () => {
    const [showSplash, setShowSplash] = useState(true);
    const [dotCount, setDotCount] = useState(4); 
    const dots = Array(dotCount).fill('.'); 
    

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000); // Adjust the duration as needed
    
    return () => clearTimeout(timer);
  }, []);
    

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prevCount) => (prevCount >= 3 ? 1 : prevCount + 1)); 
    }, 500); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={showSplash ? 'splash-screen' : 'splash-screen hidden'}>
          <h1>Loading {dots }</h1>
    </div>
  );
};

export default Splash;
